import gql from 'graphql-tag';

import { Query } from 'core/index';

export const ACTIVITY_FIELDS = gql`
  fragment activityFields on ActivityConnection {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        id
        date
        action
        origin {
          id
          slug
          type
          parentContent {
            id
            type
            whitelabel
          }
          imageFallbackChar
          avatar {
            id
            path
            url
          }
        }
        content {
          id
          slug
          title
          type
          version
          whitelabel
          origin {
            id
            type
            slug
            version
            parentContent {
              id
              type
              slug
              whitelabel
              parentContent {
                id
                type
                slug
                whitelabel
              }
            }
          }
          creator {
            id
            username
            profile {
              id
              imageFallbackChar
              avatar {
                id
                path
                url
              }
            }
          }
          parentContent {
            id
            slug
            type
            whitelabel
            avatar {
              id
              path
              url
            }
            parentContent {
              id
              slug
              type
              whitelabel
            }
          }
        }
      }
    }
  }
`;

const ACTIVITY_FEED = gql`
  ${ACTIVITY_FIELDS}
  query ActivityFeed($batchSize: Int, $cursor: String) {
    activity(first: $batchSize, after: $cursor) {
      ...activityFields
    }
  }
`;

export class MyActivityFeedQuery extends Query {
  static conf = {
    GQL: ACTIVITY_FEED,
    varNames: ['batchSize', 'cursor'],
    resultPath: 'activity',
  };
}

const GLOBAL_ACTIVITY_FEED = gql`
  ${ACTIVITY_FIELDS}
  query GlobalActivityFeed($batchSize: Int, $cursor: String) {
    globalActivity(first: $batchSize, after: $cursor) {
      ...activityFields
    }
  }
`;

export class GlobalActivityFeedQuery extends Query {
  static conf = {
    GQL: GLOBAL_ACTIVITY_FEED,
    varNames: ['batchSize', 'cursor'],
    resultPath: 'globalActivity',
  };
}

const CONTRIBUTED_PROJECTS = gql`
  query ContributedProjects($username: String!) {
    profile(username: $username) {
      result(username: $username) {
        id
        contributedProjects(sortBy: "recent") {
          totalCount
          edges {
            node {
              id
              slug
              parentContent {
                id
                slug
                type
                whitelabel
              }
            }
          }
        }
      }
    }
  }
`;

export class ContributedProjectsQuery extends Query {
  static conf = {
    GQL: CONTRIBUTED_PROJECTS,
    varNames: ['username'],
    resultPath: 'profile.result',
  };
}
